<template>
  <b-container class="pl-0 pr-0 pt-0 pb-0">
    <b-row v-if="loading">
      <b-col>
        <font-awesome-icon icon="spinner" size="lg" spin/>
      </b-col>
    </b-row>
    <b-row class="text-left" v-else>
      <b-col>
        <b-form-group
          id="surveyselectgroup"
          breakpoint="md"
          label="Survey"
          label-for="surveyselect"
          validated
        >
          <b-form-select v-model="selected_survey" :options="surveys" class="mb-3" id="surveyselect" @input="selectionMade($event)" @change="selectionMade($event)" required />
        </b-form-group>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import * as API from "@/services/API"

export default {
  name: 'SurveySelection',
  // properties you can pass to this component
  props: {
    survey: {
      default: null,
      type: Object
    }
  },
  // this is reactive data and will be updated in the view
  data: function () {
    return {
      surveys: [],
      pagination: {
        totalRecords: 1,
        totalPages: 1,
        page: 1,
        pageSize: 1
      },
      // props down, events up.
      selected_survey: this.survey || null,
      loading: false
    }
  },
  created: function () {

    this.loading = true
    return API.getSurveys(this.$root.token).then(res => {
      this.surveys = [ { value: null, text: 'Please select a survey' } ]
        .concat(
          res.results.map(i => {
            return {
              value: i, // store the full object here
              text: i.title
            }
          })
        )
      this.pagination = res.pagination
      this.loading = false
    })
  },
  methods: {
    selectionMade (e) {
      this.$emit('update:survey', this.selected_survey)
    }
  }
}
</script>
/*
    "results": [
        {
            "href": "https://api.surveymonkey.com/v3/surveys/157598244",
            "nickname": "",
            "id": "157598244",
            "title": "Test Survey"
        }
    ],
    "pagination": {
        "totalRecords": 1,
        "totalPages": 1,
        "page": 1,
        "pageSize": 1
    }
}
*/


// WEBPACK FOOTER //
// src/components/SurveySelection.vue